import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../components/Blog.css";
import {useLocation} from 'react-router-dom';
import html2canvas from "html2canvas";
import { QRCodeCanvas } from "qrcode.react";


const BlogDetails = () => {

  const [qrType, setQrType] = useState("url");
  const [qrInput, setQrInput] = useState("");
  const [qrData, setQrData] = useState("");
  const location = useLocation();
  const qrRef = useRef();


  // json viewer tool
  const generateQRCode = () => {
 if (!qrInput.trim()) {
      alert("Please enter valid  to generate the QR code.");
      return;
    }

    let formattedData;
    formattedData = `upi://pay?pa=7869353726-2@ybl&pn=Shree General Store&am=${qrInput}&cu=INR`; 
    setQrData(formattedData);
  }

  const downloadQRCode = () => {

    html2canvas(qrRef.current,{
    scale: 3, // increase resolution
    useCORS: true
  }).then((canvas) => {
      const url = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = url;
      a.download = "qrcode.png";
      a.click();
    });
    };

  useEffect(() => {
  }, []);
  return (
    <>
      {/* BLOG HERO */}
      <section className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>
                Shree General Store - Payment QR Code
              </h1>
              <p>
                 by <strong>Code Inputs</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BLOG CONTENT */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* BLOG MAIN CONTENT */}
            <div className="col-lg-12">
              <div className="blog-card" style={{width:"80%",margin:"0 auto"}}>

            <Form>
              <Form.Group className="mt-3">
                <Form.Label>Amount:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Payment Amount"
                  value={qrInput}
                  onChange={(e) => setQrInput(e.target.value)}
                />
              </Form.Group>
              <Button variant="primary" className="mt-3" onClick={generateQRCode}>
                Generate QR Code
              </Button>
            </Form>
            {qrData && (
              <div className="mt-4 text-center">
                <div ref={qrRef} style={{
          width: "300px",
          padding: "20px",
          background: "#fff",
          margin: "auto",
          textAlign: "center",
          border: "1px solid #ddd",
          borderRadius: "10px"
        }}>
        <img 
  src="/sgslogo200.png" 
  height="100px" 
  style={{ display: "block", margin: "0 auto 5px auto" }}
/>

<h3 style={{ margin: "0" }}>
  SHREE GENERAL STORE
</h3><br/>
                <div style={{ position: "relative", width: "250px", height: "250px" }}>
                <QRCodeCanvas value={qrData} size={250} level="H" /> {/* Use QRCodeCanvas */}
                 <img
    src="/sgslogosmallicon.png"
    alt="sgslogosmalliconlogo"
    style={{
      position: "absolute",
      top: "38%",
      left: "48%",
      transform: "translate(-50%, -50%)",
      height:"50px",
      background:"#fff",
      padding: "3px",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.5)"
    }}
  />

      </div><br/>
      <span className="fw-bold">UPI ID:<br/> 7869353726-2@ybl</span><br/><br/>
      <span className="fw-bold">Amount:<br/> ₹{qrInput}.00</span><br/><br/>
      <span className="fw-bold">Scan to Pay with any UPI App</span>
      </div>
                <br />
                <Button variant="success" className="mt-3" onClick={downloadQRCode}>
                  Download QR Code
                </Button>
              </div>
            )}
          </div>
        </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
